import { StyledAlignContent } from './styled';
import { AlignContentProps } from './types';

export type { AlignContentProps } from './types';

export const AlignContent = ({
    alignment = 'left',
    position = 'top',
    children,
    ...rest
}: AlignContentProps) => {
    return (
        <StyledAlignContent alignment={alignment} position={position} {...rest}>
            {children}
        </StyledAlignContent>
    );
};
